import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import * as _ from 'lodash';

import { UserService } from '../../core/user/user.service';

import { TeamMember } from './team.model';
import { Company } from '../companies/company.model';
import { Project } from '../projects/project.model';
import { Task } from '../../shared/tasks/task.model';

@Injectable()
export class TeamService extends UserService {
  previouslySelectedTeamMember: TeamMember;
  previouslySelectedExternalUser: TeamMember;

  addCompanyToTeamMember(teamMember: TeamMember, company: Company) {
    // create a spoof company and use the id - otherwise we get a json circular reference
    const spoofCompany = new Company();
    spoofCompany._id = company._id;

    // push the spoofed company to the team member
    teamMember.companies.unshift(spoofCompany);

    this.saveTeamMember(teamMember);
  }

  addTaskToTeamMember(teamMember: TeamMember, task: Task) {
    // create a spoof company and use the id - otherwise we get a json circular reference
    const clone: TeamMember = _.cloneDeep(teamMember);

    // push the spoofed company to the team member
    const spoofTask = new Task();
    spoofTask._id = task._id;

    // push the spoofed company to the team member
    clone.tasks.unshift(spoofTask);

    this.saveTeamMember(clone);
  }

  addProjectToTeamMember(teamMember: TeamMember, project: Project) {
    // create a spoof company and use the id - otherwise we get a json circular reference
    const spoofProject = new Project();
    spoofProject._id = project._id;

    // push the spoofed company to the team member
    teamMember.projects.unshift(spoofProject);

    this.saveTeamMember(teamMember);
  }

  removePropertyFromTeamMember(teamMember: TeamMember, itemToRemove: any, propertyName: string) {
    // add the team member to the company
    if (teamMember.hasOwnProperty(propertyName)) {
      // check if the array is non-string (i.e. whether it has been populated)
      if (this.checkForNonString(teamMember[ propertyName ])) {
        teamMember[ propertyName ] = teamMember[ propertyName ].filter(p => p._id !== itemToRemove._id);
      } else {
        teamMember[ propertyName ] = teamMember[ propertyName ].filter(p => p !== itemToRemove._id);
      }

      this.saveTeamMember(teamMember);
    }
  }

  checkForNonString(arrayToCheck: any[]): boolean {
    let somethingIsNotString = false;

    arrayToCheck.forEach(function (item) {
      if (typeof item !== 'string') {
        somethingIsNotString = true;
      }
    });

    return somethingIsNotString;
  }

  saveTeamMember(teamMember: TeamMember) {
    this.editUser(teamMember)
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(error => console.log(error));
  }

  getTeamMembers(): Observable<TeamMember[]> {
    return this.httpClient.get<TeamMember[]>('/api/teammembers', {
      headers: { ignoreLoadingBar: '' }
    });
  }

  getExternalUsers(): Observable<TeamMember[]> {
    return this.httpClient.get<TeamMember[]>('/api/externalUsers', {
      headers: { ignoreLoadingBar: '' }
    });
  }

  getTeamMemberFromEmails(emails: string): Observable<TeamMember[]> {
    return this.httpClient.get<TeamMember[]>(`/api/users/emails/${ emails }`);
  }

  getTeamMemberFromId(id: string): Observable<TeamMember> {
    return this.httpClient.get<TeamMember>(`/api/teammembers/${ id }`);
  }
}



// WEBPACK FOOTER //
// ./client/app/features/team/team.service.ts